import React from 'react';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Modal from 'react-bootstrap/Modal';
import PulseLoader from "react-spinners/PulseLoader";
import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import $ from 'jquery';
import Table from 'react-bootstrap/Table';
import { CheckSession} from "../GlobalScript";

export default function KMCAPITest() {
    const navigate = useNavigate();
    const [KMCItemAvailabilityResponse, setKMCItemAvailabilityResponse] = useState(null);
    const [KMCRfcItemCheckResponse, setKMCRfcItemCheckResponse] = useState(null);
    const [KMCOrderStatusResponse, setKMCOrderStatusResponse] = useState(null);
    const [KMCOrderDetailResponse, setKMCOrderDetailResponse] = useState(null);
    const [KMCForwarderAddressResponse, setKMCForwarderAddressResponse] = useState(null);
    const [KMCFreightSummaryResponse, setKMCFreightSummaryResponse] = useState(null); 
    const [KMCItemComponentResponse, setKMCItemComponentResponse] = useState(null); 
    const [KMCItemNumberCheckResponse, setKMCItemNumberCheckResponse] = useState(null); 
    const [KMCLoyaltySummaryReponse, setKMCLoyaltySummaryReponse] = useState(null); 
    const [KMCPromoCodeReponse, setKMCPromoCodeReponse] = useState(null); 
    const [KMCPromoCodeCheckReponse, setKMCPromoCodeCheckReponse] = useState(null); 
    const [KMCRfcStatusReponse, setKMCRfcStatusReponse] = useState(null); 
    const [KMCBackOrdersResponse, setKMCBackOrdersResponse] = useState(null); 
    const [KMCExportAllocResponse, setKMCExportAllocResponse] = useState(null); 
    const [KMCItemSubDetailResponse, setKMCItemSubDetailResponse] = useState(null); 
    const [KMCItemSubListResponse, setKMCItemSubListResponse] = useState(null); 
    const [KMCRfcExchStaResponse, setKMCRfcExchStaResponse] = useState(null); 
    const [KMCRfcDocumentResponse, setKMRfcDocumentResponse] = useState(null); 
    const [KMCSubmitOrderResponse, setKMCSubmitOrderResponse] = useState(null); 
    const [KMCRfcSubmitReturnRequestResponse, setKMCRfcSubmitReturnRequestResponse] = useState(null); 
    const [KMCBackOrderUpdateRquestResponse, setKMCBackOrderUpdateRquestResponse] = useState(null); 
    const [KMCOrderCancelRequestResponse, setKMCOrderCancelRequestResponse] = useState(null); 
    const [KMCRfcExchSubmitRequestResponse, setKMCRfcExchSubmitRequestResponse] = useState(null); 
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (loading === false) {
            CheckSession();
            setLoading(true);
        }    
    }, [loading])
    const KMCItemAvailabilityClick = async () => {
        const res = await CheckAvailability('ItemAVailabilityRequestXML')
        setKMCItemAvailabilityResponse(res);
    }
    const KMCRfcItemCheckClick = async () => {
        const res = await CheckAvailability('KMCRfcItemCheckRequestXML')
        setKMCRfcItemCheckResponse(res);
    }
    const KMCRfcStatusRequestClick = async () => {
        const res = await CheckAvailability('KMCRfcStatusRequestXML')
        setKMCRfcStatusReponse(res);
    }
    const KMCOrderStatusCheckClick = async () => {
        const res = await CheckAvailability('KMCOrderStatusRequestXML')
        setKMCOrderStatusResponse(res);
    }
    const KMCOrderDetailCheckClick = async () => {
        const res = await CheckAvailability('KMCOrderDetailRequestXML')
        setKMCOrderDetailResponse(res);
    }
    const KMCForwarderAddressCheckClick = async () => {
        const res = await CheckAvailability('KMCForwarderAddressRequestXML')
        setKMCForwarderAddressResponse(res);
    }
    const KMCFreightSummaryCheckClick = async () => {
        const res = await CheckAvailability('KMCFreightSummaryRequestXML')
        setKMCFreightSummaryResponse(res);
    }
    const KMCItemComponentCheckClick = async () => {
        const res = await CheckAvailability('KMCItemComponentRequestXML')
        setKMCItemComponentResponse(res);
    }
    const KMCItemNumberCheckClick = async () => {
        const res = await CheckAvailability('KMCItemNumberCheckRequestXML')
        setKMCItemNumberCheckResponse(res);
    }
    const KMCLoyaltySummaryCheckClick = async () => {
        const res = await CheckAvailability('KMCLoyaltySummaryRequestXML')
        setKMCLoyaltySummaryReponse(res);
    }
    const KMCPromoCodeClick = async () => {
        const res = await CheckAvailability('KMCPromoCodeRequestXML')
        setKMCPromoCodeReponse(res);
    }
    const KMCPromoCodeCheckClick = async () => {
        const res = await CheckAvailability('KMCPromoCodeCheckRequestXML')
        setKMCPromoCodeCheckReponse(res);
    }
    const KMCBackOrdersRequestCheckClick = async () => {
        const res = await CheckAvailability('KMCBackOrdersRequestXML')
        setKMCBackOrdersResponse(res);
    }
    const KMCExportAllocRequestCheckClick = async () => {
        const res = await CheckAvailability('KMCExportAllocRequestXML')
        setKMCExportAllocResponse(res);
    }
    const KMCItemSubDetailRequestCheckClick = async () => {
        const res = await CheckAvailability('KMCItemSubDetailRequestXML')
        setKMCItemSubDetailResponse(res);
    }
    const KMCItemSubListRequestCheckClick = async () => {
        const res = await CheckAvailability('KMCItemSubListRequestXML')
        setKMCItemSubListResponse(res);
    }
    const KMCRfcExchStaRequestCheckClick = async () => {
        const res = await CheckAvailability('KMCRfcExchStaRequestXML')
        setKMCRfcExchStaResponse(res);
    }
    const KMRfcDocumentRequestCheckClick = async () => {
        const res = await CheckAvailability('KMCRfcDocumentRequestXML')
        setKMRfcDocumentResponse(res);
    }
    const KMCSubmitOrderClick = async () => {
        const res = await CheckAvailability('KMCSubmitOrderTestXML')
        setKMCSubmitOrderResponse(res);
    }
    const KMCRfcSubmitReturnRequestClick = async () => {
        const res = await CheckAvailability('KMCRfcSubmitReturnXML')
        setKMCRfcSubmitReturnRequestResponse(res);
    }
    const KMCBackOrderUpdateRquestClick = async () => {
        const res = await CheckAvailability('KMCBackOrderUpdateRquestXML')
        setKMCBackOrderUpdateRquestResponse(res);
    }
    const KMCOrderCancelRequestClick = async () => {
        const res = await CheckAvailability('KMCOrderCancelRequestXML')
        setKMCOrderCancelRequestResponse(res);
    }
    const KMCRfcExchSubmitRequestClick = async () => {
        const res = await CheckAvailability('KMCRfcExchSubmitRequestXML')
        setKMCRfcExchSubmitRequestResponse(res);
    }
    const CheckAvailability = async (name) => {
        try {
            debugger;
            //const response = await fetch("kmcapi/KMCItemAvailability");
            const response = await fetch("kmcapi/Get/" + name );
            if (response.status !== 200) {
                throw new Error("Invlaid user!");
            }
            //const res = await response.json();
            const res = await response.text();
            return res;
            //setKMCItemAvailabilityResponse(res);
        }
        catch (e) {
            console.log('Error');
            //setKMCItemAvailabilityResponse('Error');
            return "Error";
        }

    }
  
    return (
        <>
            <Container className="checkout-container main-container">
                <Row className="order-table order-page">
                    <Col className="hr-left checkout-title-under">
                        <Button variant="danger" onClick={KMCItemAvailabilityClick}>
                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                            </svg>
                            KMCItemAvailability
                        </Button>
                    </Col>
                    {KMCItemAvailabilityResponse && <Col className="hr-left checkout-title-under">
                        {KMCItemAvailabilityResponse }
                    </Col>}
                   
                </Row>
                <Row className="order-table order-page">
                    <Col className="hr-left checkout-title-under">
                        <Button variant="danger" onClick={KMCRfcStatusRequestClick}>
                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                            </svg>
                            KMCRfcStatusRequest
                        </Button>
                    </Col>
                    {KMCRfcStatusReponse && <Col className="hr-left checkout-title-under">
                        {KMCRfcStatusReponse}
                    </Col>}

                </Row>
                <Row className="order-table order-page">
                    <Col className="hr-left checkout-title-under">
                        <Button variant="danger" onClick={KMCRfcItemCheckClick}>
                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                            </svg>
                            KMCRfcItemCheck
                        </Button>
                    </Col>
                    {KMCRfcItemCheckResponse && <Col className="hr-left checkout-title-under">
                        {KMCRfcItemCheckResponse}
                    </Col>}

                </Row>
                <Row className="order-table order-page">
                    <Col className="hr-left checkout-title-under">
                        <Button variant="danger" onClick={KMCOrderStatusCheckClick}>
                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                            </svg>
                            KMCOrderStatus
                        </Button>
                    </Col>
                    {KMCOrderStatusResponse && <Col className="hr-left checkout-title-under">
                        {KMCOrderStatusResponse}
                    </Col>}

                </Row>
                <Row className="order-table order-page">
                    <Col className="hr-left checkout-title-under">
                        <Button variant="danger" onClick={KMCOrderDetailCheckClick}>
                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                            </svg>
                            KMCOrderDetail
                        </Button>
                    </Col>
                    {KMCOrderDetailResponse && <Col className="hr-left checkout-title-under">
                        {KMCOrderDetailResponse}
                    </Col>}

                </Row>
                <Row className="order-table order-page">
                    <Col className="hr-left checkout-title-under">
                        <Button variant="danger" onClick={KMCForwarderAddressCheckClick}>
                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                            </svg>
                            KMCForwarderAddress
                        </Button>
                    </Col>
                    {KMCForwarderAddressResponse && <Col className="hr-left checkout-title-under">
                        {KMCForwarderAddressResponse}
                    </Col>}

                </Row>
                <Row className="order-table order-page">
                    <Col className="hr-left checkout-title-under">
                        <Button variant="danger" onClick={KMCFreightSummaryCheckClick}>
                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                            </svg>
                            KMCFreightSummary
                        </Button>
                    </Col>
                    {KMCFreightSummaryResponse && <Col className="hr-left checkout-title-under">
                        {KMCFreightSummaryResponse}
                    </Col>}

                </Row>
                <Row className="order-table order-page">
                    <Col className="hr-left checkout-title-under">
                        <Button variant="danger" onClick={KMCItemComponentCheckClick}>
                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                            </svg>
                            KMCItemComponent
                        </Button>
                    </Col>
                    {KMCItemComponentResponse && <Col className="hr-left checkout-title-under">
                        {KMCItemComponentResponse}
                    </Col>}

                </Row>
                <Row className="order-table order-page">
                    <Col className="hr-left checkout-title-under">
                        <Button variant="danger" onClick={KMCItemNumberCheckClick}>
                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                            </svg>
                            KMCItemNumberCheck
                        </Button>
                    </Col>
                    {KMCItemNumberCheckResponse && <Col className="hr-left checkout-title-under">
                        {KMCItemNumberCheckResponse}
                    </Col>}

                </Row>
                <Row className="order-table order-page">
                    <Col className="hr-left checkout-title-under">
                        <Button variant="danger" onClick={KMCLoyaltySummaryCheckClick}>
                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                            </svg>
                            KMCLoyaltySummary
                        </Button>
                    </Col>
                    {KMCLoyaltySummaryReponse && <Col className="hr-left checkout-title-under">
                        {KMCLoyaltySummaryReponse}
                    </Col>}

                </Row>
                <Row className="order-table order-page">
                    <Col className="hr-left checkout-title-under">
                        <Button variant="danger" onClick={KMCPromoCodeClick}>
                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                            </svg>
                            KMCPromoCodeRequest
                        </Button>
                    </Col>
                    {KMCPromoCodeReponse && <Col className="hr-left checkout-title-under">
                        {KMCPromoCodeReponse}
                    </Col>}

                </Row>
                <Row className="order-table order-page">
                    <Col className="hr-left checkout-title-under">
                        <Button variant="danger" onClick={KMCPromoCodeCheckClick}>
                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                            </svg>
                            KMCPromoCodeCheckRequest
                        </Button>
                    </Col>
                    {KMCPromoCodeCheckReponse && <Col className="hr-left checkout-title-under">
                        {KMCPromoCodeCheckReponse}
                    </Col>}

                </Row>
                <Row className="order-table order-page">
                    <Col className="hr-left checkout-title-under">
                        <Button variant="danger" onClick={KMCBackOrdersRequestCheckClick}>
                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                            </svg>
                            KMCBackOrdersRequest
                        </Button>
                    </Col>
                    {KMCBackOrdersResponse && <Col className="hr-left checkout-title-under">
                        {KMCBackOrdersResponse}
                    </Col>}

                </Row>
                <Row className="order-table order-page">
                    <Col className="hr-left checkout-title-under">
                        <Button variant="danger" onClick={KMCExportAllocRequestCheckClick}>
                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                            </svg>
                            KMCExportAllocRequest
                        </Button>
                    </Col>
                    {KMCExportAllocResponse && <Col className="hr-left checkout-title-under">
                        {KMCExportAllocResponse}
                    </Col>}

                </Row>
                <Row className="order-table order-page">
                    <Col className="hr-left checkout-title-under">
                        <Button variant="danger" onClick={KMCItemSubDetailRequestCheckClick}>
                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                            </svg>
                            KMCItemSubDetailRequest
                        </Button>
                    </Col>
                    {KMCItemSubDetailResponse && <Col className="hr-left checkout-title-under">
                        {KMCItemSubDetailResponse}
                    </Col>}

                </Row>
                <Row className="order-table order-page">
                    <Col className="hr-left checkout-title-under">
                        <Button variant="danger" onClick={KMCItemSubListRequestCheckClick}>
                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                            </svg>
                            KMCItemSubListRequest
                        </Button>
                    </Col>
                    {KMCItemSubListResponse && <Col className="hr-left checkout-title-under">
                        {KMCItemSubListResponse}
                    </Col>}

                </Row>
                <Row className="order-table order-page">
                    <Col className="hr-left checkout-title-under">
                        <Button variant="danger" onClick={KMCRfcExchStaRequestCheckClick}>
                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                            </svg>
                            KMCRfcExchStaRequest
                        </Button>
                    </Col>
                    {KMCRfcExchStaResponse && <Col className="hr-left checkout-title-under">
                        {KMCRfcExchStaResponse}
                    </Col>}

                </Row>
                <Row className="order-table order-page">
                    <Col className="hr-left checkout-title-under">
                        <Button variant="danger" onClick={KMRfcDocumentRequestCheckClick}>
                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                            </svg>
                            KMRfcDocumentRequest
                        </Button>
                    </Col>
                    {KMCRfcDocumentResponse && <Col className="hr-left checkout-title-under">
                        {KMCRfcDocumentResponse}
                    </Col>}

                </Row>
                <Row className="order-table order-page">
                    <Col className="hr-left checkout-title-under">
                        <Button variant="danger" onClick={KMCSubmitOrderClick}>
                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                            </svg>
                            KMCSubmitOrder(!!)
                        </Button>
                    </Col>
                    {KMCSubmitOrderResponse && <Col className="hr-left checkout-title-under">
                        {KMCSubmitOrderResponse}
                    </Col>}

                </Row>
                <Row className="order-table order-page">
                    <Col className="hr-left checkout-title-under">
                        <Button variant="danger" onClick={KMCRfcSubmitReturnRequestClick}>
                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                            </svg>
                            KMCRfcSubmitReturn(!!)
                        </Button>
                    </Col>
                    {KMCRfcSubmitReturnRequestResponse && <Col className="hr-left checkout-title-under">
                        {KMCRfcSubmitReturnRequestResponse}
                    </Col>}

                </Row>
                <Row className="order-table order-page">
                    <Col className="hr-left checkout-title-under">
                        <Button variant="danger" onClick={KMCBackOrderUpdateRquestClick}>
                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                            </svg>
                            KMCBackOrderUpdateRquest(!!)
                        </Button>
                    </Col>
                    {KMCBackOrderUpdateRquestResponse && <Col className="hr-left checkout-title-under">
                        {KMCBackOrderUpdateRquestResponse}
                    </Col>}

                </Row>
                <Row className="order-table order-page">
                    <Col className="hr-left checkout-title-under">
                        <Button variant="danger" onClick={KMCOrderCancelRequestClick}>
                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                            </svg>
                            KMCOrderCancelRequest(!!)
                        </Button>
                    </Col>
                    {KMCOrderCancelRequestResponse && <Col className="hr-left checkout-title-under">
                        {KMCOrderCancelRequestResponse}
                    </Col>}

                </Row>
                <Row className="order-table order-page">
                    <Col className="hr-left checkout-title-under">
                        <Button variant="danger" onClick={KMCRfcExchSubmitRequestClick}>
                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                            </svg>
                            KMCRfcExchSubmitRequest(!!)
                        </Button>
                    </Col>
                    {KMCRfcExchSubmitRequestResponse && <Col className="hr-left checkout-title-under">
                        {KMCRfcExchSubmitRequestResponse}
                    </Col>}

                </Row>
            </Container>
        </>
    );
} 